import Papa from "papaparse";
import { CardData } from "./CardData";

export class DeckConverter {
  toCsv(cards: CardData[]): string {
    const dataToExport = cards.map((c) => {
      const card = new CardData();
      card.front = c.front;
      card.back = c.back;
      card.romanization = c.romanization;
      return card;
    });

    return Papa.unparse(dataToExport);
  }

  fromCsv(csv: string): CardData[] {
    const result = Papa.parse<CardData>(csv);

    const errors = result.errors;
    if (errors && errors.length > 0) {
      errors.forEach((err) => {
        console.log(err);
      });
    }
    return result.data.map((x) => {
      const card = new CardData();
      card.front = x.front;
      card.back = x.back;
      return card;
    });
  }
}
